import "../../Projects/Genome/Genome.css";
import Hero from "../../Projects/Genome/Hero.jsx";
import AboutUs from "../../Projects/Genome/AboutUs.jsx";
import Banner from "../../Projects/Genome/Banner.jsx";
import Palette from "../../Projects/Genome/Palette.jsx";
import Card from "../../Projects/Genome/Card.jsx";
import Footer from "../../general/Footer.jsx";

export default function GenomePage() {
  return (
    <div className="genome-page">
      <Hero />
      <AboutUs />
      <Banner />
      <Palette />
      <Card />
      <Footer />
    </div>
  );
}
